module.exports = __webpack_public_path__ + "img/aeroland-clinic-image-01.e770dba1.png";